import {CategoryDetails, SubCategory} from "@/types";
import { default as allServices } from '@/content/services';


export const getRelatedSubCategoriesByCategory = (category: SubCategory) =>{
    const headCategory = allServices[category.headCategory.id];

    const relatedSubCategories = headCategory.subCategories?.filter((sc: SubCategory) => sc.id !== category.id);

    return relatedSubCategories
}

export const getAllUnRelatedSubCategoriesByCategory = (category: SubCategory) =>{
    const subCategories: SubCategory[] = [];

    const otherHeadCategories = Object.values(allServices).filter((hc: CategoryDetails)=> hc.id !== category.headCategory.id);

    otherHeadCategories.forEach((headCategory: CategoryDetails) => {
        headCategory.subCategories?.forEach((subCategory: SubCategory) => {
            subCategories.push(subCategory);
        });
    });

    return subCategories;
}

export const getAllServiceSlugs = () =>{
    const slugs: string[] = [];

    Object.values(allServices).forEach((service : CategoryDetails) => {
        service.subCategories?.forEach((sc: SubCategory) => {
            if (sc.slug) {
                slugs.push(sc.slug);
            }
        });
    });

    return slugs;
}
